import React from "react";
import "../styles/Idecaba.css";
import { Link } from "react-router";
function Banner({ titleSection, linkName, nameSection }) {
  return (
    <div className="banner banner-dark bg-dark text-white py-3">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <h4 className="mb-0 text-center text-md-start">{titleSection}</h4>
          </div>
          <div className="col-12 col-md-6">
            <nav aria-label="Navegación secundaria">
              <ol className="breadcrumb mb-0 justify-content-center justify-content-md-end">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    {linkName}
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white-50"
                  aria-current="page"
                >
                  {nameSection}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
